import { render, staticRenderFns } from "./AddCommissionRule.vue?vue&type=template&id=8682f41a&scoped=true"
import script from "./AddCommissionRule.vue?vue&type=script&lang=js"
export * from "./AddCommissionRule.vue?vue&type=script&lang=js"
import style0 from "./AddCommissionRule.vue?vue&type=style&index=0&id=8682f41a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8682f41a",
  null
  
)

export default component.exports